var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHomeStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 94,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-3.2%",
    y: "-3.8%",
    width: "106.4%",
    height: "110.8%",
    filterUnits: "objectBoundingBox",
    id: "icon-home-star_svg__a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0",
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0",
    "in": "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "shadowOffsetOuter3",
    result: "shadowBlurOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0",
    "in": "shadowBlurOuter3",
    result: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon-home-star_svg__a)",
    transform: "translate(-162 -69)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(167 78.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.228 36.814l-8.749-26.441a1.692 1.692 0 00-1.602-1.167H18.7a1.69 1.69 0 00-1.601 1.167l-8.75 26.44a1.717 1.717 0 00.232 1.538c.317.445.827.708 1.37.708h76.675c.543 0 1.053-.263 1.37-.708a1.717 1.717 0 00.232-1.537",
    fillOpacity: 0.4,
    fill: "#C3F1E3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FEF0DE",
    fillRule: "nonzero",
    opacity: 0.5,
    cx: 47.5,
    cy: 71.5,
    rx: 47.5,
    ry: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.228 36.814l-8.749-26.441a1.692 1.692 0 00-1.602-1.167H18.7a1.69 1.69 0 00-1.601 1.167l-8.75 26.44a1.717 1.717 0 00.232 1.538c.317.445.827.708 1.37.708h76.675c.543 0 1.053-.263 1.37-.708a1.717 1.717 0 00.232-1.537z",
    stroke: "#076447",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9.465 65.5h77.647V39.06H9.465z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#076447",
    strokeWidth: 1.5,
    fill: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.465 70.5h77.647V39.06H9.465z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.6,
    fill: "#C3F1E3",
    d: "M48.289 70.5h7.595V54.171H48.29z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#076447",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M48.289 70.5h7.595V54.171H48.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.6,
    fill: "#C3F1E3",
    d: "M40.693 70.5h7.596V54.171h-7.596z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#076447",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M40.693 70.5h7.596V54.171h-7.596z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.509 12.619h-8.44a1.697 1.697 0 01-1.688-1.706V7.5c0-.943.756-1.706 1.688-1.706h8.44c.931 0 1.688.763 1.688 1.706v3.412c0 .943-.757 1.706-1.688 1.706",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.509 12.619h-8.44a1.697 1.697 0 01-1.688-1.706V7.5c0-.943.756-1.706 1.688-1.706h8.44c.931 0 1.688.763 1.688 1.706v3.412c0 .943-.757 1.706-1.688 1.706z",
    stroke: "#076447",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.509 1.056c0-.475-.757-.861-1.688-.861h-5.064c-.932 0-1.688.386-1.688.861v4.74h8.44v-4.74z",
    fill: "#C3F1E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.509 1.056c0-.475-.757-.861-1.688-.861h-5.064c-.932 0-1.688.386-1.688.861v4.74h8.44v-4.74z",
    stroke: "#076447",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M20.437 55.568l6.752-6.823v-1.157h-6.752z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#076447",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20.437 61.677h6.752V50.589h-6.752z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.877 51.48c0 .613-.491.938-1.095.938h-7.937c-.605 0-1.096-.325-1.096-.938v-2.22c0-.61.491-1.106 1.096-1.106h7.937c.604 0 1.095.496 1.095 1.107v2.22z",
    fill: "#C3F1E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.877 51.48c0 .613-.491.938-1.095.938h-7.937c-.605 0-1.096-.325-1.096-.938v-2.22c0-.61.491-1.106 1.096-1.106h7.937c.604 0 1.095.496 1.095 1.107v2.22zM18.75 61.677h10.127",
    stroke: "#076447",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M69.388 55.568l6.752-6.823v-1.157h-6.752z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#076447",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M69.388 61.677h6.752V50.589h-6.752z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.828 51.48c0 .613-.491.938-1.095.938h-7.937c-.605 0-1.096-.325-1.096-.938v-2.22c0-.61.491-1.106 1.096-1.106h7.937c.604 0 1.095.496 1.095 1.107v2.22z",
    fill: "#C3F1E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.828 51.48c0 .613-.491.938-1.095.938h-7.937c-.605 0-1.096-.325-1.096-.938v-2.22c0-.61.491-1.106 1.096-1.106h7.937c.604 0 1.095.496 1.095 1.107v2.22zM67.7 61.677h10.128",
    stroke: "#076447",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.785 24.845c0-.507-.223-.986-.608-1.312l-5.57-4.55a1.678 1.678 0 00-2.16 0l-5.402 4.55a1.718 1.718 0 00-.608 1.312v8.24c0 .944.756 1.706 1.688 1.706h10.972c.932 0 1.688-.762 1.688-1.705v-8.241z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.785 24.458c0-.475-.223-.925-.608-1.23l-5.57-4.27a1.763 1.763 0 00-2.16 0l-5.402 4.27a1.573 1.573 0 00-.608 1.23v7.733c0 .885.756 1.6 1.688 1.6h10.972c.932 0 1.688-.715 1.688-1.6v-7.733z",
    stroke: "#076447",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.565 34.795h-5.908v-7.677c0-.943.756-1.705 1.688-1.705h2.532c.932 0 1.688.762 1.688 1.705v7.677z",
    fillOpacity: 0.4,
    fill: "#C3F1E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.877 25.413h-2.532c-.932 0-1.688.762-1.688 1.705v5.295l5.85-5.735a1.689 1.689 0 00-1.63-1.265",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.565 33.795h-5.908v-6.858c0-.843.756-1.524 1.688-1.524h2.532c.932 0 1.688.68 1.688 1.524v6.858z",
    stroke: "#076447",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.14 24.845c0-.507-.223-.986-.608-1.312l-5.57-4.55a1.678 1.678 0 00-2.16 0l-5.402 4.55a1.718 1.718 0 00-.608 1.312v8.24c0 .944.757 1.706 1.688 1.706h10.972c.932 0 1.688-.762 1.688-1.705v-8.241z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.14 24.458c0-.475-.223-.925-.608-1.23l-5.57-4.27a1.763 1.763 0 00-2.16 0l-5.402 4.27a1.573 1.573 0 00-.608 1.23v7.733c0 .885.757 1.6 1.688 1.6h10.972c.932 0 1.688-.715 1.688-1.6v-7.733z",
    stroke: "#076447",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.92 34.795h-5.908v-7.677c0-.943.756-1.705 1.688-1.705h2.532c.932 0 1.688.762 1.688 1.705v7.677z",
    fillOpacity: 0.4,
    fill: "#C3F1E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.232 25.413H67.7c-.932 0-1.688.762-1.688 1.705v5.295l5.85-5.735a1.689 1.689 0 00-1.63-1.265",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.92 33.795h-5.908v-6.858c0-.843.756-1.524 1.688-1.524h2.532c.932 0 1.688.68 1.688 1.524v6.858z",
    stroke: "#076447",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M248.276 74.835l2.648 5.456c.212.44.625.742 1.1.813l5.92.876c1.199.177 1.678 1.676.81 2.538l-4.283 4.247a1.51 1.51 0 00-.42 1.317l1.01 5.997c.205 1.215-1.05 2.143-2.122 1.57l-5.294-2.833a1.444 1.444 0 00-1.36 0l-5.294 2.833c-1.073.573-2.328-.355-2.125-1.57l1.013-5.997a1.51 1.51 0 00-.42-1.317l-4.284-4.247c-.869-.862-.388-2.361.811-2.538l5.92-.876c.475-.07.886-.374 1.1-.813l2.646-5.456a1.452 1.452 0 012.624 0",
    fill: "#C3F1E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.457 88.76c.346.342.503.833.421 1.317l-.83 4.93c4.49-4.623 9.203-9.516 13.363-13.85l-.384-.058c-.48-.07-.89-.374-1.105-.815l-2.646-5.454a1.452 1.452 0 00-2.624 0l-2.647 5.454c-.212.441-.624.745-1.101.815l-5.917.876c-1.201.175-1.68 1.676-.812 2.538l4.282 4.247z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.276 74.835l2.648 5.456c.212.44.625.742 1.1.813l5.92.876c1.199.177 1.678 1.676.81 2.538l-4.283 4.247a1.51 1.51 0 00-.42 1.317l1.01 5.997c.205 1.215-1.05 2.143-2.122 1.57l-5.294-2.833a1.444 1.444 0 00-1.36 0l-5.294 2.833c-1.073.573-2.328-.355-2.125-1.57l1.013-5.997a1.51 1.51 0 00-.42-1.317l-4.284-4.247c-.869-.862-.388-2.361.811-2.538l5.92-.876c.475-.07.886-.374 1.1-.813l2.646-5.456a1.452 1.452 0 012.624 0z",
    stroke: "#076447",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
export default SvgIconHomeStar;